import { render } from "./LegalComponent.vue?vue&type=template&id=ca365680"
import script from "./LegalComponent.vue?vue&type=script&lang=js"
export * from "./LegalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__